import gabrielPic from "@/public/images/artists/gabriel.png";
import { Artist } from "@/types/types";

export const gabriel = {
  id: "133",
  name: "Gabriel",
  image: gabrielPic,
  description: `Gabriel's voice, with its rich tone and dispassionate expression, uniquely blends warmth and sobriety. Excelling in the lower registers, Gabriel adds a distinctive and captivating aspect to to modern pop arrangements.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fgabriel-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 71,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
